export default __webpack_public_path__ + "static/media/ourshopee.4c27116d.png";